export enum OPERATION_STAFF_ROLES  {
  SURGEON = 'surgeon',
  ASSISTANT = 'assistant',
  ANESTHESIOLOGIST ='anesthesiologist',
  ANESTHESIA_NURSE = 'anesthesiaNurse',
  SCRUB_NURSE = 'scrubNurse'
}